import { computed, ref, type Ref } from 'vue'
import { useAutoRefresh } from '../useAutorefresh'
import type { Tick } from '@/utils/ticks'
import type { MarketType, OhlcvTuple } from '@/utils/types'

export interface LastOhlcvState {
  timestamp: number
  candle: OhlcvTuple
}

export const useCexCexPriceLinesUpdater = (
  exLeft: Ref<string>,
  exRight: Ref<string>,
  marketTypeLeft: Ref<MarketType>,
  marketTypeRight: Ref<MarketType>,
  leftTicks: Ref<Tick[]>,
  rightTicks: Ref<Tick[]>,
) => {
  const updateSingleSide = (
    ticksSource: Ref<Tick[]>,
    candle: OhlcvTuple | undefined,
    timestamp: number,
  ) => {
    const lastTick = ticksSource.value[ticksSource.value.length - 1]
    const priceToPut = candle ? candle[4] : (lastTick?.[1] ?? null)
    if (priceToPut) {
      ticksSource.value.push([timestamp, priceToPut])
      ticksSource.value = ticksSource.value.slice(-3600)
    }
  }

  const update = () => {
    const nowTs = Math.round(+new Date() / 1000)
    updateSingleSide(leftTicks, latestBuyTick.value?.candle, nowTs)
    updateSingleSide(rightTicks, latestSellTick.value?.candle, nowTs)
  }
  const ohlcvState = ref<Record<string, LastOhlcvState>>({})

  const latestBuyTick = computed(
    () => ohlcvState.value[`${exLeft.value}_${marketTypeLeft.value}`] ?? null,
  )
  const latestSellTick = computed(
    () => ohlcvState.value[`${exRight.value}_${marketTypeRight.value}`] ?? null,
  )

  const linesRefresher = useAutoRefresh(async () => {
    update()
  }, 500)

  return {
    linesRefresher,
    ohlcvState,
    update,
  }
}
